import { useMemo } from 'react';

import {
  YAxisPercent,
  YAxisDecimal,
  YAxisCurrency,
} from '../../Axis/YAxis/index';
import {
  CLICKS,
  EVENTS,
  IMPRESSIONS,
  INSTALLS,
  PERCENT_GROUP,
  PERCENTEGE,
  USD_AMOUNT_BIG,
  USD_AMOUNT_MIDDLE,
  USD_AMOUNT_SMALL,
} from '../../Axis/index';

export const useYAxisElementsMemo = ({ yAxisGroupIds }) => {
  return useMemo(() => {
    return yAxisGroupIds.map((yAxisGroupId, i, groups) => {
      const orientation = i ? 'right' : 'left';
      const hide = groups.length > 2;
      const key = yAxisGroupId;
      const yAxisId = yAxisGroupId;
      let commonProps = {
        orientation,
        hide,
        key,
        yAxisId,
      };

      if (hide) {
        commonProps = {
          ...commonProps,
          height: 0,
          width: 0,
        };
      }

      switch (yAxisGroupId) {
        case PERCENTEGE:
          return <YAxisPercent width={30} {...commonProps} />;
        case IMPRESSIONS:
          return <YAxisDecimal width={60} {...commonProps} />;
        case EVENTS:
        case CLICKS:
        case INSTALLS:
          return <YAxisDecimal width={50} {...commonProps} />;
        case PERCENT_GROUP:
          return <YAxisPercent width={30} {...commonProps} />;
        case USD_AMOUNT_SMALL:
          return <YAxisCurrency width={44} {...commonProps} />;
        case USD_AMOUNT_MIDDLE:
          return <YAxisCurrency width={52} {...commonProps} />;
        case USD_AMOUNT_BIG:
          return <YAxisCurrency width={60} {...commonProps} />;
        default:
          return <YAxisDecimal {...commonProps} />;
      }
    });
  }, [yAxisGroupIds]);
};
